


















































































import { Vue, Component } from "vue-property-decorator";
import { auth, settings, ICapabilities, VIPUser } from "@/loader/public";

@Component
export default class SidebarMenu extends Vue {
	public loggingOut: boolean = false;
	public hoverOption: boolean = false;
	public hoverProject: boolean = false;

	public get user(): VIPUser | null  {
		return auth.user;
	}

	public get cap(): ICapabilities  {
		return auth.user?.capabilities || {};
	}

	public get inOptions(): boolean {
		return this.hoverOption || /options/.test(this.$router.currentRoute.path);
	}

	public get logo(): string {
		return settings.logo_url;
	}

	public get company_name(): string {
		return settings.company_name;
	}

	public logOut() {
		this.loggingOut = true;
		// Route changing is done in App.vue when isLoggedIn is changed
		auth.logout()
		this.loggingOut = false;
	}
}
